import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NotificationService } from '../../core/services/notification/notification.service';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { DetailedLogsPerChangeDateDto } from '../../core/services/GPRMV1Service.Generated';
import { AppService } from '../../core/services/app.service';

import moment from 'moment';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { MatDatepicker } from '@angular/material/datepicker';
import { NotificationModel } from '../../shared/models/notification-data.model';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';

@Component({
    selector: 'app-notification-details-popup',
    templateUrl: './notification-details-popup.component.html',
    styleUrls: ['./notification-details-popup.component.scss'],
    standalone: false
})

export class NotificationDetailsPopupComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild('picker') datePicker: MatDatepicker<any>;

  displayedColumns: string[] = ['productName', 'status', 'elementName'];
  labelPosition = 'before';
  notificationDetailedLogs: DetailedLogsPerChangeDateDto[];
  notificationDetailsFilter: UntypedFormGroup;
  previousDateRange: NotificationModel;
  scrollChangeSummaryLogId: number = 0;
  isLoaderActive = true;
  
  scrollIndex: number = 0;

  private _subscriptions: Subject<boolean> = new Subject();
  
  @ViewChild(CdkVirtualScrollViewport) cdkVirtualScrollViewport: CdkVirtualScrollViewport;

  constructor (
    private _notifService: NotificationService,
    public _bsModalRef: BsModalRef,
    private _appService: AppService,
  ) { }

  ngOnInit () {
    this.createFormGroup();
    this.getDetailedLogs();

    this.previousDateRange = this._notifService.getLastReadDateRange();
  }

  /**
   * Checking the text as shrank or not
   * @param element targeted html element
   * @returns boolean
   */
  checkOverflow(element: HTMLElement) {
    return !(element.offsetWidth < element.scrollWidth);
  }
  
  ngAfterViewInit () {
    this.datePickerCloseEvent();
    setTimeout(() => {
      this.cdkVirtualScrollViewport.scrollToIndex(this.scrollIndex, 'smooth');
    }, 600);
  }

  createFormGroup () {
    const dateData = this._notifService.getDateData();
    this.scrollChangeSummaryLogId = this._notifService.getScrollChangeSummaryLogId();

    this.notificationDetailsFilter = new UntypedFormGroup({
      startDate: new UntypedFormControl(dateData.startDate),
      endDate: new UntypedFormControl(dateData.endDate),
    });
  }

  ngOnDestroy (): void {
    this._subscriptions.unsubscribe();
  }
  
  closePopover () {
    this._bsModalRef.hide();
  }

  /**
   * Tracking date picker close event
   */
  datePickerCloseEvent() {
    this.datePicker.closedStream
      .pipe(takeUntil(this._subscriptions))
      .subscribe(() => {
        const dateRangeHasChanged = this._notifService.checkDateChanges(this.notificationDetailsFilter.value, this.previousDateRange);

        // If date range has changed then calling the API
        if (dateRangeHasChanged){
          this.isLoaderActive = true;
          this.getDetailedLogs();
        }
        this.scrollChangeSummaryLogId = -1;
      });
  }

  /**
   * Calling an API to get the detailed notification log
   */
  getDetailedLogs() {
    const dateFilter = this.notificationDetailsFilter.value;
    const calculationUrlId = this._appService.getCalculationUrlId();
    const startDate = new Date(moment(dateFilter.startDate).toISOString());
    const endDate = new Date(moment(dateFilter.endDate).toISOString());

    this._appService.gprMaterialsService.getDetailedLogs(calculationUrlId, startDate, endDate)
      .pipe(takeUntil(this._subscriptions))
      .subscribe((resp: DetailedLogsPerChangeDateDto[]) => {
        this.notificationDetailedLogs = resp;
        this.isLoaderActive = false;
        this.scrollIndex = this.notificationDetailedLogs.findIndex(element => element.associatedChangeSummaryLogId === this.scrollChangeSummaryLogId);
      }, () => {
        this.notificationDetailedLogs = [];
        this.isLoaderActive = false;
      });
  }
  
}
